import script from "./ProductCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategory.vue?vue&type=script&setup=true&lang=js"

import "./ProductCategory.vue?vue&type=style&index=0&id=08c388bd&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c388bd"]])

export default __exports__